export const staticHost = 'https://static1.laiyifen.com'

export const staticImgPath = '/files/cdn-lyf-cpn/image'